/**
 * ComingSoonBadge Component
 * 
 * Displays a "Coming Soon" badge to indicate features that are not yet available.
 * Used to highlight upcoming services or functionality in the application.
 * 
 * @example
 * ```tsx
 * <ComingSoonBadge />
 * ```
 */

interface ComingSoonBadgeProps {
  /** Optional custom className for additional styling */
  className?: string;
  /** Text to display in the badge. Defaults to translation key for i18n support */
  text?: string;
}

export default function ComingSoonBadge({ className = '', text }: ComingSoonBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r from-accent-500 to-accent-600 text-white shadow-md ${className}`}
      aria-label="This feature is coming soon"
    >
      {text || 'Coming Soon'}
    </span>
  );
}
